import { message } from "antd";
import { getTranslateNsT } from "@/utils/getTranslateNsT";

export const handlePaycode = (code: number | string) => {
  if (code === 200) return;
  const errorT = getTranslateNsT("error");
  message.error(errorT(`error_${code}`));
};
